export default __webpack_public_path__ + "static/media/megamenu-img.8b069df4.png";